var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0.5H10C4.47715 0.5 0 4.97715 0 10.5V25.5C0 31.0228 4.47715 35.5 10 35.5H25C30.5228 35.5 35 31.0228 35 25.5V10.5C35 4.97715 30.5228 0.5 25 0.5Z",
    fill: "#FFAA8C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.5,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_528_1000",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_528_1000",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACKUlEQVRIib2VsWsTcRTHP+93aQolwUBxUYdMcVHEzc1M7hUajA6tdHC0Qdqgg2Sqliak/gFFt9oE1NnFZFEQCp0zZaqDBqrXpba/33NImjbm0ktD9AvH3eO99/2+7929O/jHkEEJ3ViNE/dSYGKIxkOZrP2NMS1825CFvH+mgL4tpTCabgf4GPGD6nrg7CRiplEOUPki9540AgU6k2cR2eXXUf30NGHQjdU4MbkDJsa+fScLed/0VcW9FMB5yQFkIe+zrx8RJo95+gXETaOudV7yHhHFx7afW6S/xItiOBiFvAsjPkZiEORgzOhxoJXSPOoe4OSKbhVXBnYZ+YzaTcks18MEug60slYDfQ3cQvQIVAYeqo/A1HSrlB/KgVZK86C3gVdMRAoyk9s7q0krKxfR6FfEPQdWwx1oZ6kmvFByAMk8+466FyBTWi3eDRcQTYLWhyHvwjM/BuZUL6H67URgjNDKy+sA2MMWBO7BKKSFKN6FaaymwF1FXFOyT5tjE4Cp+1gb7QTbMru8fZwZk4CJYrUh2aVaX6Z9kh2QG/q+nBiaU921ztVlALzgT/rxW/QBSHBoy8OIaHUtDSaHsos6H3UtfNsIqpVTTYuolNsBTaLeTZnJ7Wl1bREnjxGSf8n8BE1LZnnnrGF6fji6WU5ibAFhDuQh6ByQBq2jnNxfwx6RyJuhljLQvsqn7pRCQWaX1sOIhhYA0EpxHSWB8wqSzTVHJf8v+AOEB+NMyF+yOQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.1a4b57885dbf1972a9bfbc0222c2fd98.svg";
export { ForwardRef as ReactComponent };